<template>
  <div class="home mt-0">

    <div v-if="loadinguser==true" class="notification is-warning">
      Loading user details ... 
    </div>

    <div class="columns is-variable is-6" v-if="loadinguser==false">
      <div class="column is-two-fifths">
        <div class="box quick-find-panel">
          <h2 class="title is-4">Quick Find</h2>
          <p class="subtitle is-6">Open specific records in a new tab.</p>

          <label class="label" for="quick-booking-id">Booking</label>
          <form @submit.prevent="quickFindBooking" class="field has-addons mb-4">
            <div class="control is-expanded">
              <input
                id="quick-booking-id"
                v-model="bookingSearch"
                class="input"
                type="text"
                placeholder="Booking ID"
              />
            </div>
            <div class="control">
              <button class="button is-primary" type="submit">Find Booking</button>
            </div>
          </form>

          
          <label class="label" for="quick-client-id">Client</label>
          <form @submit.prevent="quickFindClient" class="field has-addons mb-4">
            <div class="control is-expanded">
              <input
                id="quick-client-id"
                v-model="clientSearch"
                class="input"
                type="text"
                placeholder="Client name or group name"
              />
            </div>
            <div class="control">
              <button class="button is-link" type="submit">Find Client</button>
            </div>
          </form>
          
          <!--
          <label class="label" for="quick-member-id">Member</label>
          <form @submit.prevent="quickFindMember" class="field has-addons">
            <div class="control is-expanded">
              <input
                id="quick-member-id"
                v-model="memberSearch"
                class="input"
                type="text"
                placeholder="Member ID"
              />
            </div>
            <div class="control">
              <button class="button is-info" type="submit">Find Member</button>
            </div>
          </form>-->
        </div>
      </div>

      <div class="column is-three-fifths">
        <div class="box section-panel">
          <h2 class="title is-4">Jump to Section</h2>
          <p class="subtitle is-6">Use shortcuts to move around the system.</p>

          <div class="columns is-multiline section-buttons">
            <div class="column is-half">
              <router-link to="/applications"><button class="button is-info is-fullwidth is-medium">Applications</button></router-link>
            </div>
            <div class="column is-half">
              <router-link to="/bookings/new"><button class="button is-info is-fullwidth is-medium">Bookings</button></router-link>
            </div>
            <div class="column is-half" v-if="SYSTEM_TYPE=='HOMECARE'">
              <router-link to="/activities/listclients"><button class="button is-info is-fullwidth is-medium">Client Activites</button></router-link>
            </div>
            <div class="column is-half">
              <router-link to="/members"><button class="button is-info is-fullwidth is-medium">Members</button></router-link>
            </div>
            <div class="column is-half" v-if="user.billing==1">
              <router-link to="/billing"><button class="button is-info is-fullwidth is-medium">Billing</button></router-link>
            </div>
            <div class="column is-half">
              <router-link to="/notes"><button class="button is-info is-fullwidth is-medium">Notes</button></router-link>
            </div>
            <div class="column is-half" style="display:none">
              <router-link to="/tickets/my-tickets"><button class="button is-warning is-fullwidth is-medium">Tickets</button></router-link>
            </div>
            <div class="column is-half">
              <button class="button is-danger is-fullwidth is-medium" @click="logout()">Logout</button>
            </div>
          </div>
        </div>
      </div>
    </div>

      
    
  </div>
</template>

<script>
import MemberMixin from '@/mixins/MemberMixin.js';

export default {
  name: 'Home',
  components: {
    
  },
  mixins: [MemberMixin],
  data: function () {
        return {
                
                API_NAME: process.env.VUE_APP_API_NAME,
                accessToken: '',
                user: [],
                loadinguser: true,
                SYSTEM_TYPE: process.env.VUE_APP_SYSTEM_TYPE,
                bookingSearch: '',
                clientSearch: '',
                memberSearch: '',
               
        }
    },
  methods: {
          logout() {
              if(confirm('Are you sure you want to logout ?'))
              {
                  this.$auth.logout({
                  returnTo: window.location.origin
                });
              }
      },
      openInNewTab(path) {
        const resolved = this.$router.resolve({ path: path });
        window.open(resolved.href, '_blank');
      },
      quickFindBooking() {
        const bookingId = (this.bookingSearch || '').trim();
        if(bookingId === '') {
          this.openInNewTab('/bookings/search');
          return;
        }
        this.openInNewTab('/bookings/' + encodeURIComponent(bookingId));
      },
      quickFindClient() {
        const clientId = (this.clientSearch || '').trim();
        if(clientId === '') {
          this.openInNewTab('/billing/client-list');
          return;
        }
        this.openInNewTab('/billing/client-list?search=' + encodeURIComponent(clientId));
      },
      quickFindMember() {
        const memberId = (this.memberSearch || '').trim();
        if(memberId === '') {
          this.openInNewTab('/members');
          return;
        }
        this.openInNewTab('/members/' + encodeURIComponent(memberId));
      },

    },
    created() {
          this.getAccessToken()
            .then(() => { 
                this.getUserSelf()
            });
          
        },
}
</script>

<style scoped>
.quick-find-panel,
.section-panel {
  height: 100%;
}

.section-buttons .button {
  font-weight: 600;
}
</style>
